import router from '@/router';
import all from '@/api/all.js';

export default {
    updateUsername({ commit }, payload) {
        payload.user.updateProfile({
            displayName: payload.displayName,
        }).then(() => {
            // If username update is success
            // update in localstorage
            const newUserData = Object.assign({}, payload.user.providerData[0]);
            newUserData.displayName = payload.displayName;
            commit('UPDATE_USER_INFO', newUserData, { root: true });

            // If reload is required to get fresh data after update
            // Reload current page
            if (payload.isReloadRequired) {
                router.push(router.currentRoute.query.to || '/');
            }
        }).catch((err) => {
            payload.notify({
                time: 8800,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
            });
        });
    },


    login({ commit }, payload) {
        return new Promise((resolve, reject) => {
            all.postLogin(payload).then((response) => {
                if (response.data.status) {
                    var datas = response.data.data[0];
                    commit('UPDATE_USER_INFO', datas, { root: true });
                    commit('SET_BEARER');
                    resolve(response);
                } else {
                    reject({ message: 'Data Login Salah' });
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
};
